import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'NOTIFICATION_SETTINGS';
export const {
    action: fetchNotificationSettings,
    success: fetchNotificationSettingsSuccess,
    failed: fetchNotificationSettingsFailed,
} = createAction(`${domain}/FETCH`);

export const {
    action: updateNotificationSettings,
    success: updateNotificationSettingsSuccess,
    failed: updateNotificationSettingsFailed,
} = createAction(`${domain}/UPDATE`, notificationSettings => ({notificationSettings}));
